require('./menu.js');

import './swiper.js';
import AboutPagesGoogleMaps from './AboutPagesGoogleMap';
import FrontpageGoogleMap from './FrontpageGoogleMap';
import PickStoreModal from './PickStoreModal';
import PickStoreModalNew from './PickStoreModalNew';
import FindStoreGoogleMap from './FindStoreGoogleMap';
import ColorPicker from './ColorPicker';
import ProductArchive from './ProductArchive';
import FavoriteList from './FavoriteList';
import MiniCart from './MiniCart';
import ColorPickerSidebar from './ColorPickerSidebar.js';
//import SizePicker from './SizePicker.js';
import PickProductStoreModal from './PickProductStoreModal';

const productArchive = new ProductArchive();
const colorPicker = new ColorPicker();
const favoriteList = new FavoriteList();

const miniCart = new MiniCart();
//const sizePicker = new SizePicker();
const colorPickerSidebar = new ColorPickerSidebar();
const aboutPagesGoogleMap = new AboutPagesGoogleMaps();
const pickStoreModal = new PickStoreModal();
const pickStoreModalNew = new PickStoreModalNew();
const findStoreGoogleMap = new FindStoreGoogleMap();
const frontpageMap = new FrontpageGoogleMap();
const pickProductStoreModal = new PickProductStoreModal();